import React, { useState, useEffect } from "react";
import "./SetGoalsModal.css";

function SetGoalsModal({ isOpen, onClose, onSave, currentGoals }) {
  const [goals, setGoals] = useState({
    goal_lead: 10,
    goal_first_meeting: 5,
    goal_additional_meetings: 3,
    goal_offer_sent: 2,
    goal_signed: 1,
  });

  useEffect(() => {
    if (currentGoals) {
      setGoals(currentGoals);
    }
  }, [currentGoals]);

  const handleChange = (field, value) => {
    const numValue = parseInt(value) || 0;
    setGoals(prev => ({
      ...prev,
      [field]: numValue >= 0 ? numValue : 0,
    }));
  };

  const handleSubmit = () => {
    onSave(goals);
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="set-goals-modal-overlay" onClick={onClose}>
      <div className="set-goals-modal" onClick={e => e.stopPropagation()}>
        <div className="set-goals-modal-header">
          <h2>Set Your Weekly Goals</h2>
          <button className="close-modal-btn" onClick={onClose}>
            <span className="material-icons">close</span>
          </button>
        </div>

        <div className="set-goals-modal-body">
          <p className="goals-description">
            Set your weekly recruiting targets. Track how many leads you aim to
            move through each stage per week.
          </p>

          <div className="goals-form">
            <div className="goal-input-group">
              <label htmlFor="goal_lead">
                <span className="goal-label-icon material-icons">
                  person_add
                </span>
                <span className="goal-label-text">Lead</span>
              </label>
              <input
                id="goal_lead"
                type="number"
                min="0"
                value={goals.goal_lead}
                onChange={e => handleChange("goal_lead", e.target.value)}
                className="goal-input"
              />
              <span className="goal-suffix">per week</span>
            </div>

            <div className="goal-input-group">
              <label htmlFor="goal_first_meeting">
                <span className="goal-label-icon material-icons">event</span>
                <span className="goal-label-text">1st Meeting</span>
              </label>
              <input
                id="goal_first_meeting"
                type="number"
                min="0"
                value={goals.goal_first_meeting}
                onChange={e =>
                  handleChange("goal_first_meeting", e.target.value)
                }
                className="goal-input"
              />
              <span className="goal-suffix">per week</span>
            </div>

            <div className="goal-input-group">
              <label htmlFor="goal_additional_meetings">
                <span className="goal-label-icon material-icons">
                  event_repeat
                </span>
                <span className="goal-label-text">Additional Meetings</span>
              </label>
              <input
                id="goal_additional_meetings"
                type="number"
                min="0"
                value={goals.goal_additional_meetings}
                onChange={e =>
                  handleChange("goal_additional_meetings", e.target.value)
                }
                className="goal-input"
              />
              <span className="goal-suffix">per week</span>
            </div>

            <div className="goal-input-group">
              <label htmlFor="goal_offer_sent">
                <span className="goal-label-icon material-icons">send</span>
                <span className="goal-label-text">Offer Sent</span>
              </label>
              <input
                id="goal_offer_sent"
                type="number"
                min="0"
                value={goals.goal_offer_sent}
                onChange={e => handleChange("goal_offer_sent", e.target.value)}
                className="goal-input"
              />
              <span className="goal-suffix">per week</span>
            </div>

            <div className="goal-input-group">
              <label htmlFor="goal_signed">
                <span className="goal-label-icon material-icons">
                  check_circle
                </span>
                <span className="goal-label-text">Signed</span>
              </label>
              <input
                id="goal_signed"
                type="number"
                min="0"
                value={goals.goal_signed}
                onChange={e => handleChange("goal_signed", e.target.value)}
                className="goal-input"
              />
              <span className="goal-suffix">per week</span>
            </div>
          </div>
        </div>

        <div className="set-goals-modal-footer">
          <button className="cancel-goals-btn" onClick={onClose}>
            Cancel
          </button>
          <button className="save-goals-btn" onClick={handleSubmit}>
            Save Goals
          </button>
        </div>
      </div>
    </div>
  );
}

export default SetGoalsModal;
